const getOnClickHandlers = handler => ({
  onClick: handler,
  onKeyPress: e => {
    if (e.key === 'Enter') handler();
  }
});

export default getOnClickHandlers;
